module.exports = __webpack_public_path__ + "img/hr-steel-furnace-working.9db432fb.png";